import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import styles from "./custom.module.css";
import userCard from "../assets/img/user/card/green/01.png";
import userCard2 from "../assets/img/user/card/green/02.png";
import userCard3 from "../assets/img/user/card/green/03.png";
import userCard4 from "../assets/img/user/card/green/04.png";
import UserHeader from "./components/UserHeader";
import UserSubHeader from "./components/UserSubHeader";
import noDataImg from "../assets/img/banner/no-data.png";

import { getEarningData } from "../redux/actions/earning";

const Earnings = () => {
  const dispatch = useDispatch();
  const earningData = useSelector((state) => state.earning.earningData);
  
  const [reportType, setReportType] = useState("GR_RP");
  const [isSplLeader, setIsSplLeader] = useState(false);
  const [threeXstatus, setThreeXstatus] = useState(false);

  useEffect(() => {
    dispatch(getEarningData());
    checkSplLeaderStatus();
  }, [dispatch]);

  // Check user's spl_leader status from localStorage
  const checkSplLeaderStatus = () => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const splLeaderStatus = payload.spl_leader || 0;
        setIsSplLeader(splLeaderStatus === 1);
      }
    } catch (error) {
      console.error("Error checking spl_leader status:", error);
      setIsSplLeader(false);
    }
  };

  // ✅ CORRECT: Set threeXstatus when earningData is available
  useEffect(() => {
    if (earningData?.user3Xstatus) {
      setThreeXstatus(true);
    }
  }, [earningData]);

  // Safe data processing with null checks
  const processData = () => {
    console.log("🔍 Earnings Data:", earningData);

    // Process growth transactions
    let daillyVerTrnx = Array.isArray(earningData?.growthTrnxs) ? [...earningData.growthTrnxs] : [];
    daillyVerTrnx.forEach((element, index) => {
      element.srNo = index + 1;
    });

    // Process direct income data
    let drIncData = Array.isArray(earningData?.teammLevelReport?.[0]?.users) 
      ? [...earningData.teammLevelReport[0].users] 
      : [];
    drIncData.forEach((element, index) => {
      element.srNo = index + 1;
    });

    // Process team recurring report - SIMPLIFIED
    let teamRecurringReport = Array.isArray(earningData?.referralReport) 
      ? [...earningData.referralReport] 
      : [];
    teamRecurringReport.forEach((element, index) => {
      element.srNo = index + 1;
    });

    return { daillyVerTrnx, drIncData, teamRecurringReport };
  };

  const { daillyVerTrnx, drIncData, teamRecurringReport } = processData();
  
  // Column templates with safe value access
  const growthAmtData = (rowData) => {
    return (
      <span className="text-success fw-bold">
        + ${rowData?.growthAmount || 0}
      </span>
    );
  };

  const pkgAmtData = (rowData) => {
    return <span className="text-primary">${rowData?.amount || 0}</span>;
  };

  const pkgAmtPer = (rowData) => {
    const totalBusiness = parseFloat(rowData?.total_business) || 0;
    return (
      <span className="text-primary">
        ${((totalBusiness * 5) / 100).toFixed(2)}
      </span>
    );
  };

  const calPer = (row) => {
    const reccuringROI = parseFloat(row?.income) || 0;
    const percentage = parseFloat(row?.percentage) || 0;
    return `$${((reccuringROI * percentage) / 100).toFixed(6)}`;
  };

  const eliStatus = (row) => {
    return row?.isEligible ? (
      <span className="text-success">Eligible</span>
    ) : (
      <span className="text-danger">Not Eligible</span>
    );
  };

  // Safe number formatting for display
  const formatCurrency = (value) => {
    if (value === null || value === undefined) return "0.00";
    return parseFloat(value).toFixed(2);
  };

  return (
    <div>
      <UserHeader />
      <UserSubHeader pageTitle={"Earnings"} subTitle={"Earnings"} />
      
      <section className="user-ditails-wrapper fix section-bg-5 section-padding-medium">
        <div className="container">
          <div className="row section-padding-medium wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">
            
            {/* Daily Growth Income Card */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Total Daily Growth
                        </div>
                        <p>${formatCurrency(earningData?.totalGrowthIncome)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Direct Referral Income Card */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard2} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Direct Referral Income
                        </div>
                        <p>${formatCurrency(earningData?.totaldirRefIncome)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Team Recurring Growth Card */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard3} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Team Recurring Growth
                        </div>
                        <p>${formatCurrency(earningData?.teamRecurringROIonROITotal)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Total Earning Card */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard4} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>
                          Total Earning
                        </div>
                        <p>${formatCurrency(earningData?.totalEarning)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Reports Section */}
        <div className="section-padding-medium">
          <div className="container">
            <div className="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">
              <div className="mt-3">
                <div className="card">
                  <div className="card-header">
                    <div className={styles.columns}>
                      <div className="col p-2">
                        <button
                          className={`btn ${reportType === "GR_RP" ? "btn-success" : "btn-outline-success"}`}
                          onClick={() => setReportType("GR_RP")}
                        >
                          Growth Income Report
                        </button>
                      </div>
                      
                      {/* ✅ CORRECT: Conditional rendering for 3X status */}
                      {threeXstatus && (
                        <div className="col p-2">
                          <div className="alert alert-success text-center mb-0">
                            <h4 className="m-0 text-dark">🎉 Congratulations! You have Achieved Booster @ 1% Daily! 🎊</h4>
                          </div>
                        </div>
                      )}
                      
                      {/* Conditionally render Direct Income Report button based on spl_leader status */}
                      {isSplLeader && (
                        <div className="col p-2">
                          <button
                            className={`btn ${reportType === "DI_RP" ? "btn-dark" : "btn-outline-dark"}`}
                            onClick={() => setReportType("DI_RP")}
                          >
                            Direct Income Report
                          </button>
                        </div>
                      )}
                      
                      <div className="col p-2">
                        <button
                          className={`btn ${reportType === "GI_RP" ? "btn-primary" : "btn-outline-primary"}`}
                          onClick={() => setReportType("GI_RP")}
                        >
                          Level Income Report
                        </button>
                      </div>
                    </div>
                    <div className="card-title bg-dark text-light rounded p-3 text-center">
                      <h5 className="m-0 me-2">
                        {reportType === "GR_RP" && "Growth Income Report"}
                        {reportType === "DI_RP" && "Direct Income Report"}
                        {reportType === "GI_RP" && "Level Income Report"}
                      </h5>
                    </div>
                  </div>

                  {/* Report Content */}
                  <div className="card-body">
                    {reportType === "GR_RP" && (
                      <div className="table-responsive table-striped rounded">
                        {daillyVerTrnx.length > 0 ? (
                          <DataTable
                            value={daillyVerTrnx}
                            paginator
                            rows={10}
                            className="table table-dark"
                          >
                            <Column field="srNo" header="#" sortable />
                            <Column field="packageName" header="Package Name" sortable />
                            <Column body={pkgAmtData} header="Package Amount" sortable />
                            <Column body={growthAmtData} header="Growth Amount" sortable />
                            <Column field="daysSinceCreation" header="No Of Days" sortable />
                            <Column field="activationTime" header="Activation Date" sortable />
                            <Column field="date" header="Credit Date" sortable />
                          </DataTable>
                        ) : (
                          <div className="no-data text-center rounded rounded-bottom">
                            <img src={noDataImg} alt="No Data" className="img-fluid" />
                            <p className="mt-2">No growth income data available</p>
                          </div>
                        )}
                      </div>
                    )}

                    {reportType === "DI_RP" && isSplLeader && (
                      <div className="table-responsive table-striped rounded">
                        {drIncData.length > 0 ? (
                          <DataTable
                            value={drIncData}
                            paginator
                            rows={10}
                            className="table table-dark"
                          >
                            <Column field="srNo" header="#" sortable />
                            <Column field="referral_id" header="User Id" sortable />
                            <Column field="total_business" header="Total Package Amount" sortable />
                            <Column body={pkgAmtPer} header="Direct Income" sortable />
                            <Column field="first_package_activation_date" header="Activation Date" sortable />
                          </DataTable>
                        ) : (
                          <div className="no-data text-center rounded rounded-bottom">
                            <img src={noDataImg} alt="No Data" className="img-fluid" />
                            <p className="mt-2">No direct income data available</p>
                          </div>
                        )}
                      </div>
                    )}

                    {reportType === "GI_RP" && (
                      <div className="table-responsive table-striped rounded">
                        {teamRecurringReport.length > 0 ? (
                          <DataTable
                            value={teamRecurringReport}
                            paginator
                            rows={10}
                            className="table table-dark"
                          >
                            <Column field="srNo" header="#" sortable />
                            <Column field="userId" header="User Id" sortable />
                            <Column field="packageName" header="Package Name" sortable />
                            <Column field="packageAmount" header="Package Amount" sortable />
                            <Column body={calPer} header="Recurring Associate Income" sortable />
                            <Column field="activationDate" header="Activation Date" sortable />
                            <Column field="date" header="Growth Date" sortable />
                            <Column body={eliStatus} header="Eligibility Status" sortable />
                          </DataTable>
                        ) : (
                          <div className="no-data text-center rounded rounded-bottom">
                            <img src={noDataImg} alt="No Data" className="img-fluid" />
                            <p className="mt-2">No level income data available</p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Earnings;